import { useMemo } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

// Memoize static style objects to prevent re-renders
const TOOLTIP_STYLE = { 
  backgroundColor: '#1f1f1f', 
  border: '1px solid #333',
  borderRadius: '8px'
};
const TICK_STYLE = { fontSize: 12 };
const BAR_RADIUS = [0, 4, 4, 0];

export function TopTracksBarChart({ tracks }) {
  const chartData = useMemo(() => 
    tracks.map(track => ({
      name: track.title.length > 15 ? track.title.substring(0, 15) + '...' : track.title,
      plays: track.plays || 0
    })),
    [tracks]
  );

  return (
    <div className="bg-white/5 border border-white/10 rounded-xl p-6">
      <h3 className="text-lg font-semibold mb-4">Top Tracks by Plays</h3>
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="#333" />
            <XAxis type="number" stroke="#666" />
            <YAxis 
              dataKey="name" 
              type="category" 
              width={100} 
              stroke="#666"
              tick={TICK_STYLE}
            />
            <Tooltip 
              formatter={(value) => [value.toLocaleString(), 'Plays']}
              contentStyle={TOOLTIP_STYLE}
            />
            <Bar dataKey="plays" fill="#8B5CF6" radius={BAR_RADIUS} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex items-center justify-center h-[300px] text-gray-500">
          <p>No track data yet</p>
        </div>
      )}
    </div>
  );
}
